import React, { useEffect, useState } from "react";

/* Simulates the physical 16x2 LCD on the device. Cycles content frames. */
export function LcdTerminal({ telemetry, testid }) {
  const [frame, setFrame] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setFrame((f) => (f + 1) % 4), 2600);
    return () => clearInterval(id);
  }, []);

  const pad = (s, n = 16) => (s + " ".repeat(n)).slice(0, n);
  const has = !!telemetry;

  let l1 = "CAMPUS ENERGY";
  let l2 = "  MONITOR  v2.6";

  if (has) {
    const t = telemetry;
    const frames = [
      [`L1 ${Math.round(t.phases.L1.voltage)}V ${Math.round(t.phases.L1.power)}W`, `L2 ${Math.round(t.phases.L2.voltage)}V ${Math.round(t.phases.L2.power)}W`],
      [`TEMP ${t.temperature.toFixed(1)}C`, `FAN ${t.fan_speed}%  PF.${String(t.power_factor).split(".")[1] || "00"}`],
      [`TOTAL ${Math.round(t.total_power)}W`, `PIR:${t.pir ? "ON " : "OFF"} LED:${t.light ? "ON" : "OFF"}`],
      [`GAS:${Math.round(t.gas_ppm ?? 0)}ppm`, (t.gas_quality ?? "----").padEnd(8).slice(0, 8)],
    ];
    [l1, l2] = frames[frame];
  }

  return (
    <div className="lcd-screen rounded-md p-4 select-none" data-testid={testid}>
      <div className="text-[10px] tracking-[0.3em] opacity-50 mb-2">LCD 16×2 · I2C 0x27</div>
      <div className="text-lg leading-7">
        <div data-testid={`${testid}-line1`}>{pad(l1)}</div>
        <div data-testid={`${testid}-line2`}>
          {pad(l2)}
          <span className="caret">▌</span>
        </div>
      </div>
    </div>
  );
}
